import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Grid } from '@emburse/embark-core';
import Step1 from './Step1';
import { CreateExpenseReportContext } from '../../utils/CreateExpenseReportContext';
import Step2 from './Step2';
import AlertMessage from '../AlertMessage';
const withContainerWrapper = (Component) => {
    return function (props) {
        return (_jsx(Grid, { container: true, sx: { m: '0 0 48px 0' }, children: _jsxs(Grid, { item: true, xs: 12, sm: 10, md: 8, children: [_jsx(AlertMessage, {}), _jsx(Component, { ...props })] }) }));
    };
};
function MultiStep() {
    const { stepNumber } = useContext(CreateExpenseReportContext);
    if (stepNumber === 2) {
        return _jsx(Step2, {});
    }
    return _jsx(Step1, {});
}
export default withContainerWrapper(MultiStep);
